import { morphdomIgnore } from "web-ui/morphdom/ignore"

export function BlankOptionPlugin() {
  const tomSelect = this

  tomSelect.on("initialize", () => {
    const button = document.createElement("button")
    button.setAttribute("type", "button")
    button.setAttribute("title", "Clear")
    button.setAttribute("class", "clear-button")

    tomSelect.control.appendChild(button)

    button.addEventListener("click", (e) => {
      clearItem()
      e.preventDefault()
      e.stopPropagation()
    })

    button.addEventListener("keydown", (e) => {
      const navigationKeys = ["Tab", "Escape", "PageDown", "PageUp", "End", "Home"]

      if (navigationKeys.includes(e.key)) {
        return
      }

      if (e.key === "Enter") {
        clearItem()
      }

      e.preventDefault()
      e.stopPropagation()
    })

    button.addEventListener("focus", (e) => {
      morphdomIgnore(tomSelect.input, true)
    })

    button.addEventListener("blur", (e) => {
      if (tomSelect.isFocused) {
        return
      }

      morphdomIgnore(tomSelect.input, false)
    })
  })

  function clearItem() {
    tomSelect.clear()

    if (!tomSelect.isOpen) {
      tomSelect.focus_node.focus()
    } else {
      tomSelect.refreshOptions()
    }
  }

  tomSelect.hook("after", "setup", () => {
    toggleBlankOptionSelected()

    // Tom select will insert a blank option when configured for single mode and no options are present
    // Remove the blank option from the list of search results - Matt, Stephen, Fri Nov 14 2025
    delete tomSelect.options[""]
  })

  tomSelect.on("item_add", toggleBlankOptionSelected)

  function blankOptionSelected() {
    const value = tomSelect.input.value

    return value === ""
  }

  function toggleBlankOptionSelected() {
    requestAnimationFrame(() => {
      tomSelect.wrapper.classList.toggle("blank-option-selected", blankOptionSelected())
    })
  }
}
